"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6.382 4.14c-.342.197-.729.476-.97.913-.66 1.198-1.476 4.175 1.597 9.497 3.072 5.321 6.058 6.103 7.426 6.13.5.01.934-.185 1.276-.383l2.275-1.313a1.5 1.5 0 0 0 .549-2.05l-1.077-1.865a1.5 1.5 0 0 0-2.05-.55l-.756.437c-.586.339-1.158.338-1.533.009-.525-.462-1.261-1.286-2.096-2.733-.835-1.446-1.181-2.496-1.319-3.182-.098-.488.188-.984.774-1.323l.757-.437a1.5 1.5 0 0 0 .549-2.049l-1.078-1.866a1.5 1.5 0 0 0-2.049-.549z"
}), 'TelephoneFilled');
//# sourceMappingURL=index.js.map